import ViewUser from '../../components/Users/ViewUser'

const ViewUserPage = () => {
  return (
    <div>
      <ViewUser></ViewUser>
    </div>
  )
}

export default ViewUserPage